"use strict";

module.exports = function (file) {
  return require('@/' + file + '.vue').default;
}; // vue-loader at least v13.0.0+